import React, { FC, useState } from 'react'
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons'
import { InputRightElement, InputGroup, IconButton } from '@chakra-ui/react'

import { InputProps, Input } from '../Input'

export type PasswordProps = InputProps

export const PasswordInput: FC<PasswordProps> = ({ variant, ...props }) => {
  const [hidden, setHidden] = useState(true)
  const toggle = () => setHidden(!hidden)

  const isOutlined = variant === 'outlined'

  return (
    <InputGroup>
      <Input
        {...props}
        variant={variant}
        type={hidden ? 'password' : 'text'}
        placeholder="Enter your password"
        pr={48}
      />
      <InputRightElement width={12}>
        <IconButton
          px="xxxs"
          variant="unstyled"
          mt={isOutlined ? 8 : 2}
          h="100%"
          onClick={toggle}
          aria-label={hidden ? 'Reveal password' : 'Hide password'}
          icon={hidden ? <ViewOffIcon /> : <ViewIcon />}
          color="primary-dark"
        />
      </InputRightElement>
    </InputGroup>
  )
}
